import styled, { css } from "styled-components";

const color = ({ $outline, theme }) => {
  if ($outline) return theme.colors.primary.orange;

  return theme.colors.neutral.white;
};

const backgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.orange;
};

const hoverBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return theme.colors.primary.orange;

  return theme.colors.hues.orangeShade1;
};

const outline = ({ $outline, theme }) => {
  if ($outline) return `2px solid ${theme.colors.primary.springGreen} `;

  return "none";
};

const focusBackgroundColor = ({ $outline, theme }) => {
  if ($outline) return "transparent";

  return theme.colors.primary.springGreen;
};

const focusOutline = ({ theme }) => {
  return `4px solid ${theme.colors.hues.srpingShade1}`;
};

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px;
`;

export const TertiaryButtonStructure = css`
  color: ${color};
  background-color: ${backgroundColor};
  border: ${outline};

  &:hover:not([disabled]) {
    background-color: ${hoverBackgroundColor};
  }

  &:focus {
    background-color: ${focusBackgroundColor};
    outline: ${focusOutline};
  }
`;
